import script from "./ModalForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalForm.vue?vue&type=script&setup=true&lang=ts"

import "./ModalForm.vue?vue&type=style&index=0&id=5ff740f0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff740f0"]])

export default __exports__